import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'la-simple-table',
    imports: [CommonModule],
    template: `
    <table>
      <tr *ngFor="let row of data">
        <td>{{ row.label }}</td>
        <td class="fw-b" [class.text-end]="alignValues === 'end'">{{
          row.value || '-'
        }}</td>
      </tr>
    </table>
  `,
    styles: [
        `
      table {
        width: 100%;
        border-collapse: collapse;
        page-break-inside: avoid;
      }

      table tr:first-child {
        border-top: var(--table-border-top);
      }

      table tr:not(:last-child) {
        border-bottom: var(--table-border);
      }

      table th {
        padding: 0 8px;

        &:first-child {
          padding-left: 0;
        }
      }

      table td {
        width: 50%;
        padding: 8px;
        font-size: 10pt;
        vertical-align: top;

        &:first-child {
          padding-left: 0;
          width: 50%;
        }
      }
    `,
    ]
})
export class SimpleTableComponent {
  @Input() data: { label: string; value: string }[] = [];
  @Input() alignValues: 'start' | 'end' = 'start';
}
